import { FormProvider, UseFormReturn } from 'react-hook-form'
import { PropsWithChildren } from 'react'

type WrapperProps<TForm extends { search?: string }> = PropsWithChildren<{
  form: UseFormReturn<TForm>
  renderProvider: boolean
}>

const Wrapper = <TForm extends { search?: string } = { search: string }>({
  form,
  children,
  renderProvider,
}: WrapperProps<TForm>) => {
  if (!renderProvider) return children

  return <FormProvider {...form}>{children}</FormProvider>
}

export default Wrapper
